import React from 'react';
import { format } from 'date-fns';
import { formatDateRange, getStatusDisplayName } from '../../utils/autoplanner/taskUtils';
import { PencilIcon } from '@heroicons/react/24/outline';

const TaskDetails = ({ task, onEditTask }) => (
  <div className="ml-8 mt-4 space-y-4">
    <div className="rounded-lg bg-gray-50 p-4">
      <h5 className="mb-2 text-sm font-medium text-gray-900">Task Details</h5>
      <div className="grid grid-cols-2 gap-4 text-sm">
        <div>
          <span className="font-medium text-gray-700">Created:</span>
          <span className="ml-2 text-gray-600">
            {format(new Date(task.created_at), 'MMM dd, yyyy HH:mm')}
          </span>
        </div>
        <div>
          <span className="font-medium text-gray-700">Prompt:</span>
          <span className="ml-2 text-gray-600">{task.prompt?.name || 'Unknown Prompt'}</span>
        </div>
        <div>
          <span className="font-medium text-gray-700">Date Range:</span>
          <span className="ml-2 text-gray-600">
            {formatDateRange(task.start_date, task.end_date)}
          </span>
        </div>
        <div>
          <span className="font-medium text-gray-700">Status:</span>
          <span className="ml-2 capitalize text-gray-600">{getStatusDisplayName(task.status)}</span>
        </div>
      </div>
    </div>

    {task.autoplanner_results && task.autoplanner_results.length > 0 && (
      <div className="rounded-lg bg-blue-50 p-4">
        <h5 className="mb-2 text-sm font-medium text-blue-900">Generated Sessions</h5>
        <div className="space-y-2">
          {task.autoplanner_results.map((result, index) => (
            <div key={result.id} className="flex items-center justify-between text-sm">
              <span className="text-blue-800">
                Result #{index + 1} - {format(new Date(result.created_at), 'MMM dd, yyyy')}
              </span>
              <button
                onClick={() => onEditTask({ ...task, selectedResult: result })}
                className="text-xs font-medium text-blue-600 hover:text-blue-800"
              >
                View Details
              </button>
            </div>
          ))}
        </div>
      </div>
    )}

    {task.status === 'failed' && (
      <div className="rounded-lg bg-red-50 p-4">
        <h5 className="mb-2 text-sm font-medium text-red-900">Error Information</h5>
        <p className="text-sm text-red-700">
          This task failed to process. You may need to check availability data or try again.
        </p>
        <button
          onClick={() => onEditTask(task)}
          className="mt-2 inline-flex items-center rounded border border-red-300 px-2 py-1 text-xs font-medium text-red-700 hover:bg-red-50"
        >
          <PencilIcon className="mr-1 h-4 w-4" />
          Retry
        </button>
      </div>
    )}
  </div>
);

export default TaskDetails;
